import { HTMLElementBase } from './HTMLElementBase';
import { HTMLCollectionImp, NodeListOfImp, NodeList, HTMLCollectionOfImp } from '../collection';
import {HTMLElement} from "./HTMLElement";
/**
 * The **`HTMLTrElement`** class represents an HTML `<tr>` element.
 * 
 * [MDN Reference](https://developer.mozilla.org/docs/Web/API/HTMLTableRowElement)
 */
export class HTMLTrElement extends HTMLElement {
    constructor(tagName: string, ownerDocument?: any) {
        super(tagName, ownerDocument);
    }

    get cells(): HTMLCollectionImp {
        return this.querySelectorAll('td, th') as any;
    }

    get rowIndex(): number {
        const table = this.closest('table');
        if (!table) return -1;
        
        const allRows = table.querySelectorAll('tr');
        for (let i = 0; i < allRows.length; i++) {
            const a = allRows[i];
            if (allRows[i] === this) {
                return i;
            }
        }
        return -1;
    }

    get sectionRowIndex(): number {
        const section = this.parentElement;
        if (!section) return -1;
        
        const sectionRows = section.querySelectorAll('tr');
        for (let i = 0; i < sectionRows.length; i++) {
            // @ts-ignore
            if (sectionRows[i] === this as unknown as HTMLElement) {
                return i;
            }
        }
        return -1;
    }

    insertCell(index?: number): HTMLElement {
        const cell = this.ownerDocument.createElement('td');
        const cells = this.cells;
        
        if (index === undefined || index === -1) {
            // Append to the end
            this.appendChild(cell);
        } else {
            // Insert at specific index
            if (index >= 0 && index < cells.length) {
                const referenceCell = cells[index];
                this.insertBefore(cell, referenceCell);
            } else if (index >= cells.length) {
                this.appendChild(cell);
            }
        }
        
        // @ts-ignore
        return cell;
    }

    deleteCell(index: number): void {
        const cells = this.cells;
        if (index >= 0 && index < cells.length) {
            const cell = cells[index];
            this.removeChild(cell);
        }
    }
}